import { site } from "@/data/site";
import { Reveal } from "./Reveal";

export const DeveloperCollection = () => {
    return (
        <section
            id="developers"
            data-testid="developers-section"
            className="bg-ivory px-6 py-16 lg:px-10 lg:py-24"
        >
            <div className="mx-auto max-w-[1400px]">
                <Reveal>
                    <div className="mb-14 flex flex-col items-center text-center lg:mb-20">
                        <span className="eyebrow">Developer Collection</span>
                        <h2 className="mt-5 max-w-3xl font-serif text-4xl leading-[1.1] tracking-tight text-charcoal sm:text-5xl">
                            In the company of India's finest builders.
                        </h2>
                    </div>
                </Reveal>

                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
                    {site.developers.map((d, i) => (
                        <Reveal key={d.name} delay={(i % 3) * 0.1}>
                            <div
                                data-testid={`developer-${i}`}
                                className="group relative h-72 overflow-hidden border border-line"
                            >
                                <img
                                    src={d.image}
                                    alt={d.name}
                                    loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/85 via-charcoal/25 to-transparent" />
                                <div className="absolute inset-x-0 bottom-0 p-7">
                                    <h3 className="font-serif text-2xl text-white">
                                        {d.name}
                                    </h3>
                                    <div className="my-3 h-px w-10 bg-champagne transition-all duration-500 group-hover:w-20" />
                                    <p className="max-w-xs text-sm leading-relaxed text-white/80">
                                        {d.note}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1}>
                    <p className="mt-12 text-center text-sm text-slatey">
                        New developer partnerships added regularly.
                    </p>
                </Reveal>
            </div>
        </section>
    );
};
